let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("aZinD"), load("6aruy")]).then(() => parcelRequire('9VKkC'));